/**
 * Makes a group of <details> elements inside a container behave like an accordion:
 * opening one automatically closes any other currently open element matching the selector.
 *
 * Uses a single delegated listener on the container instead of one per <details>,
 * so it also picks up elements added to the DOM later.
 *
 * Note: the native `toggle` event does not bubble, so the listener is registered
 * in the capture phase — capturing still fires for non-bubbling events.
 */
export const initDetailsAccordion = ($container: HTMLElement, detailsSelector: string): void => {
  const isMatchingOpenDetails = ($target: EventTarget | null): $target is HTMLDetailsElement =>
    $target instanceof HTMLDetailsElement && $target.matches(detailsSelector) && $target.open

  $container.addEventListener(
    'toggle',
    (event) => {
      const $toggledDetails = event.target

      if (!isMatchingOpenDetails($toggledDetails)) return

      const $allDetails = $container.querySelectorAll<HTMLDetailsElement>(`${detailsSelector}[open]`)

      $allDetails.forEach(($details) => {
        if ($details !== $toggledDetails) $details.removeAttribute('open')
      })
    },
    true,
  )
}
